import React from 'react';
import PropTypes from 'prop-types';
import FlagIcon from './FlagIcon';

const LanguageItem = ({ language, switchLanguage, handleRequestClose, isActive, showFlag }) => {
  const { locale, name } = language;

  const handleClick = () => {
    handleRequestClose();
    switchLanguage(language);
  };

  return (
    <li className={`language-item ${isActive ? 'active' : ''}`}>
      <button
        type="button"
        className="language-item-button"
        onClick={handleClick}
        aria-current={isActive ? 'true' : undefined}
      >
        {showFlag && <FlagIcon locale={locale} size={24} />}
        <h4>{name}</h4>
      </button>
    </li>
  );
};

LanguageItem.propTypes = {
  language: PropTypes.shape({
    languageId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  switchLanguage: PropTypes.func.isRequired,
  handleRequestClose: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  showFlag: PropTypes.bool,
};

LanguageItem.defaultProps = {
  isActive: false,
  showFlag: true,
};

export default LanguageItem;
